import React, { Fragment, useState, useEffect, useContext } from "react";
import Head from "../../Head";
import FormularioClienteDt from "./NuevoCliente/FormularioClienteDt";
import BotonesOpciones from "./BotonesOpciones";
import VistaDtUsuarioCobranza from "./PantallaAntigua/VistaDtUsuarioCobranza";
import VistaDtUsuarioCobranzaEspecifico from "./BusquedaClientes/VistaDtUsuarioCobranzaEspecifico";
import "../../../../styles/Modal.css";
import BusquedaCompleta from "./BusquedaConFiltros/BusquedaCompleta";
import ClienteSeleccionado from "../ClienteSeleccionado";
import TopScroll from "../../TopScroll";
import { Context } from "../../../store/AppContext";

const VistaInicialDtCobranza = () => {
	const { store, actions } = useContext(Context);
	const titulosHead = [
		"Servicio de Direccion Tributaria de Santiago",
		"Por favor, selecciona que deseas realizar:",
	];
	const [nuevoCliente, setNuevoCliente] = useState(false);
	const [busquedaClientes, setBusquedaClientes] = useState(false);
	const [pantallaAntiguaClientes, setPantallaAntiguaClientes] = useState(false);
	const [busquedaCompleta, setBusquedaCompleta] = useState(false);
	const [tipoFiltro, setTipoFiltro] = useState(null);
	const [animar, setAnimar] = useState(false);
	const [animarModal, setAnimarModal] = useState(false);
	const [clienteSeleccionado, setClienteSeleccionado] = useState(false);
	const [clienteDtCliqueado, setClienteDtCliqueado] = useState(null);

	const HandlerNuevoCliente = (event) => {
		setNuevoCliente(true);
		setTimeout(() => {
			setAnimarModal(true);
		}, 500);
	};

	const HandlerBusquedaClientes = () => {
		setBusquedaClientes(true);
	};

	const HandlerPantallaAntigua = () => {
		actions.setSpinner(true);
		setTimeout(() => {
			setPantallaAntiguaClientes(true);
		}, 500);
	};

	const HandlerBusquedaCompleta = (event) => {
		actions.setSpinner(true);
		setTimeout(() => {
			setTipoFiltro(event.target.id);
			setBusquedaCompleta(true);
		}, 500);
	};

	//Animacion
	useEffect(() => {
		setAnimar(true);
	}, []);

	return (
		<Fragment>
			<Head contenido={titulosHead} />
			<div className='row'>
				<div className='column'>
					{!nuevoCliente && !clienteSeleccionado && <TopScroll />}
					{nuevoCliente && (
						<>
							<FormularioClienteDt
								setNuevoCliente={setNuevoCliente}
								animarModal={animarModal}
								setAnimarModal={setAnimarModal}
								setClienteDtCliqueado={setClienteDtCliqueado}
								setClienteSeleccionado={setClienteSeleccionado}
							/>
						</>
					)}
					{clienteSeleccionado && (
						<ClienteSeleccionado
							setClienteSeleccionado={setClienteSeleccionado}
							clienteDtCliqueado={clienteDtCliqueado}
						/>
					)}
					{busquedaClientes && (
						<VistaDtUsuarioCobranzaEspecifico
							setBusquedaClientes={setBusquedaClientes}
						/>
					)}
					{busquedaCompleta && (
						<BusquedaCompleta
							setBusquedaCompleta={setBusquedaCompleta}
							tipoFiltro={tipoFiltro}
						/>
					)}
					{pantallaAntiguaClientes && (
						<VistaDtUsuarioCobranza
							setPantallaAntiguaClientes={setPantallaAntiguaClientes}
						/>
					)}
					{!busquedaClientes &&
						!busquedaCompleta &&
						!clienteSeleccionado &&
						!pantallaAntiguaClientes && (
							<BotonesOpciones
								HandlerNuevoCliente={HandlerNuevoCliente}
								animar={animar}
								HandlerBusquedaClientes={HandlerBusquedaClientes}
								HandlerPantallaAntigua={HandlerPantallaAntigua}
								HandlerBusquedaCompleta={HandlerBusquedaCompleta}
							/>
						)}
					{nuevoCliente && (
						<>
							<br />
							<br />
							<br />
							<br />
							<br />
							<br />
							<br />
							<br />
							<br />
							<br />
							<br />
							<br />
							<br />
							<br />
							<br />
							<br />
							<br />
							<br />
							<br />
							<br />
							<br />
							<br />
							<br />
							<br />
							<br />
							<br />
							<br />
							<br />
							<br />
							<br />
							<br />
						</>
					)}
				</div>
			</div>
		</Fragment>
	);
};

export default VistaInicialDtCobranza;
